import type { UseQueryResult } from '@tanstack/react-query';
import { TURN_TO_DEFAULT_LOAD_LIMIT } from '../../components/turn-to/const';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { SortOptions } from '../../components/turn-to/types';
import type { ProductReviewData } from './model';

export const useTurnToProductData = (
    productId?: string,
    limit = TURN_TO_DEFAULT_LOAD_LIMIT,
    offset = 0,
    sortOption: SortOptions = 'mostRecent',
    searchString: string = '',
    filterString: string = '',
    enabled?: boolean,
): UseQueryResult<ProductReviewData, unknown> =>
    useBffGet<ProductReviewData>(
        productId ? `/turn-to/reviews/${productId}` : null,
        [{ limit, offset, sortOption, searchString, filterString, skipQuestions: true }],
        [BffQueryKey.TURN_TO_DATA, productId ?? ''],
        { enabled },
    );
